<li ngbDropdown class="nav-item dropdown-notification mr-25">
  <button
    type="button"
    class="nav-link btn"
    ngbDropdownToggle
    id="navbarNotificationDropdown"
  >
    <li [data-feather]="'help-circle'" class="ficon"></li>
  </button>
  <ul
    ngbDropdownMenu
    aria-labelledby="navbarNotificationDropdown"
    class="dropdown-menu dropdown-menu-media dropdown-menu-right"
  >
    <!-- Dropdown header -->
    <li class="dropdown-menu-header" style="background-color: #24bdd7">
      <div class="dropdown-header d-flex">
        <h3 class="notification-title mb-0 mr-auto">AYUDA</h3>
      </div>
    </li>
    <!--/ Dropdown header -->

    <!-- Dropdown content -->
 
    <li class="scrollable-container media-list" [perfectScrollbar]>
      <div *ngFor="let item of helpTextContent | keyvalue; let isFirst = first">
        <div
          *ngFor="let component of item.value | keyvalue"
          class="media d-flex align-items-start"
          [class.no-border-bottom]="!isFirst"
        >
          <div class="media-body" style="display: flex; flex-flow: column">
            <strong
              class="media-heading text-center"
              [class.title]="isFirst"
              style="font-size: larger"
              >{{ component.key }}</strong
            >
            <br />
            <span
              class="text-break media-heading"
              [class.contentText]="isFirst"
              >{{ component.value }}</span
            >
          </div>
        </div>
        <div class="mb-0" [class.border-bottom]="!isFirst"></div>
        <br *ngIf="isFirst" />
      </div>
    </li>

    <!--/ Dropdown content -->

    <!-- Dropdown footer -->
    <!--     <li class="dropdown-menu-footer">
        <button type="button" class="btn nav-link" style="background-color: #24bdd7; color:white"
            rippleEffect>
            VER MAS
        </button>
    </li> -->
    <!--/ Dropdown footer -->
  </ul>
</li>
